module.exports = __webpack_public_path__ + "static/img/04.e7fa33b4.png";